import classes from './Discovery.module.css'
import useBotsService from '../../../../services/bot/botService';
import { useBotConfig } from '../../../../context/BotConfigContext';

function Discovery() {
    const botService = useBotsService()
    const config = useBotConfig()

    const buttonClass = "DiscoveryButton"

    const handleDiscoveryClick = async (message) => {
        const text = String(message ?? '').trim()
        if (!text) return
        await botService.sendMessage(text)
    }

    const greeting = config?.botSubTitle;

    return (
        <div className={classes.Discovery}>
            <img src={config?.botIconUrl} alt="" />
            <div className={classes.Title}>
                {config?.botTitle}
            </div>
            <div className={classes.Subtitle}>
                {greeting}
            </div>
            <div className={classes.DiscoveryButtons}>
                {config?.discoveryButton?.map((button, index) => (
                    <div
                        key={index}
                        className={classes[buttonClass]}
                        onClick={() => handleDiscoveryClick(button.message)}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault()
                                handleDiscoveryClick(button.message)
                            }
                        }}
                    >
                        {button.icon?.trim() ? (
                            <img
                                src={button.icon}
                                className={classes.DiscoveryIcon}
                                alt=""
                                onError={(e) => {
                                    e.currentTarget.style.display = 'none';
                                }}
                            />
                        ) : null}
                        <div style={{ width: "10px" }}></div>
                        <div className={classes.DiscoveryText}>{button.text}</div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default Discovery;